module.exports = __webpack_public_path__ + "img/logo_white.0837371e.png";